import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@contexts/ThemeContext';
import { EpisodesProvider } from '@contexts/EpisodesContext';
import { AudioPlayerProvider } from '@contexts/AudioPlayerContext';
import { SearchProvider } from '@contexts/SearchContext';
import AppHeader from '@components/navigation/AppHeader';
import AudioPlayer from '@components/audio/AudioPlayer';
import HomePage from '@pages/HomePage';
import AllEpisodesPage from '@pages/AllEpisodesPage';
import EpisodeDetailPage from '@pages/EpisodeDetailPage';
import AppContent from './AppContent';
import { ROUTES } from '@constants/routes';

function App() {
  return (
    <ThemeProvider>
      <EpisodesProvider>
        <AudioPlayerProvider>
          <SearchProvider>
            <BrowserRouter>
              <AppHeader />
              <AppContent>
                <Routes>
                  <Route path={ROUTES.HOME} element={<HomePage />} />
                  <Route path={ROUTES.ALL_EPISODES} element={<AllEpisodesPage />} />
                  <Route path={ROUTES.EPISODE_DETAIL} element={<EpisodeDetailPage />} />
                </Routes>
              </AppContent>
              <AudioPlayer />
            </BrowserRouter>
          </SearchProvider>
        </AudioPlayerProvider>
      </EpisodesProvider>
    </ThemeProvider>
  );
}

export default App;
